import jwt_decode from "jwt-decode";
import Cookies from "js-cookie";
import moment from "moment";
import CryptoJS from "crypto-js";
import db from "../../firebase";
import { collection, addDoc } from "firebase/firestore";
import logger from "../../services/logger";
// import UserExperior from "user-experior-web";

const encryptFlag = process.env.REACT_APP_ENCRYPT_FLAG == '1'
const AES_BLOCK_SIZE = 16;
const AES_ENCRYPTION_KEY_LENGTH = 32
let logoutFlag = false;

let RSA_PUBLIC_KEY = null

async function customFetch(url, options) {
  let aesKey = null
  const startTime = Date.now();
  const method = options && options.method || 'GET';
  

  // if(Cookies.get('parameter_value') !== 'null' && Cookies.get('parameter_value') !== undefined && Cookies.get('parameter_value') !== "") {
  //   const ue = new UserExperior();
  //   ue.startRecording(Cookies.get("parameter_value"), {
  //     sessionReplay: {
  //       maskAllInputs: false,
  //       maskInputOptions: {
  //         password: true,
  //         email: true,
  //         tel: true,
  //         color: false,
  //         date: false,
  //         "datetime-local": false,
  //         month: false,
  //         number: false,
  //         range: false,
  //         search: false,
  //         text: false,
  //         time: false,
  //         url: false,
  //         week: false,
  //         textarea: false,
  //         select: false,
  //       },
  //     },
  //   });
  //   ue.setUserIdentifier(
  //     `${localStorage.getItem("in_username")}_${
  //       process.env.REACT_APP_ENVIRONMENT
  //     }`
  //   );

  //   let body = JSON.stringify(options.body);

  //   let urlName = url.split("/");

  //   let eventLog = {
  //     'body' : body,
  //     'headers': JSON.stringify(options.headers),
  //     'method': options.method,
  //     'url': url
  //   }
    
  //   ue.logEvent(urlName[urlName.length - 1], eventLog);
  // }
  if (encryptFlag) {
    if (!RSA_PUBLIC_KEY) {
      await loadRSAPublicKey()
    }

    aesKey = generateAESKey();
    const AESEncryptedKey = await encryptAESKeyWithRSA(aesKey);

    //console.log("RSA-->", AESEncryptedKey)

    url = encrypt_get_params(url, aesKey);
    let contentType = options.headers ? options.headers["Content-Type"] : undefined
  
    if (!contentType && options.body) {
      if (options.body instanceof FormData) {
        contentType = 'multipart/form-data';
      } else if (typeof options.body === 'object') {
        contentType = 'application/json'
      } else if (typeof options.body === 'string') {
        if(isvalidjson(options.body)) contentType = 'application/json'
        else if(isUrlEncoded(options.body)) contentType = 'application/x-www-form-urlencoded';
        else contentType = 'text/plain'
      }
    }

    // Log API start with decrypted payload before encryption
    try {
      logger.logApiStart(url, method, window.location.pathname, options.body, contentType);
    } catch (error) {
      console.error('Error logging API start:', error);
    }
  
    if (options.body) {
      options.body = await encrypt_post_data(options.body, contentType, aesKey);

      if(options.headers) {
        options.headers["Content-Type"] = options.headers["Content-Type"] || contentType
        if(contentType === 'multipart/form-data') delete options.headers["Content-Type"]
      }
    }
    
    options.headers = options.headers || {};
    options.headers["Security-Token"] = AESEncryptedKey
  } else {
    // Log API start when encryption is disabled
    try {
      let contentType = options.headers ? options.headers["Content-Type"] : undefined;
      if (!contentType && options.body) {
        if (options.body instanceof FormData) {
          contentType = 'multipart/form-data';
        } else if (typeof options.body === 'object') {
          contentType = 'application/json'
        } else if (typeof options.body === 'string') {
          if(isvalidjson(options.body)) contentType = 'application/json'
          else if(isUrlEncoded(options.body)) contentType = 'application/x-www-form-urlencoded';
          else contentType = 'text/plain'
        }
      }
      logger.logApiStart(url, method, window.location.pathname, options.body, contentType);
    } catch (error) {
      console.error('Error logging API start:', error);
    }
  }

  options.headers = options.headers || {};
  try {
    options.headers["X-Client-Session-ID"] = logger.getSessionId();
  } catch (error) {
    console.error('Error attaching session ID header:', error);
  }
  if ("api-token" in options.headers) {
    options.headers["api-token"] = localStorage.getItem("api_token");
    return await isTokenExpired(url, options, aesKey);
  } else {
    return await call_api(url, options);
  }
}

const loadRSAPublicKey = async () => {
  try {
    const response = await fetch('/keys/rsa_public_key.pem');
    if (!response.ok) {
      throw new Error('Failed to load RSA public key');
    }
    const rawKey = await response.text();
    RSA_PUBLIC_KEY = rawKey.replace(/-----.*-----|\s/g, '');
    console.log("RSA Public Key Loaded", RSA_PUBLIC_KEY);
  } catch (error) {
    console.error("Error loading RSA public key:", error);
  }
};

const importRSAPublicKey = async (pemKey) => {
  const publicKeyBytes = base64ToUint8Array(pemKey);
  return window.crypto.subtle.importKey(
    'spki',
    publicKeyBytes,
    { name: 'RSA-OAEP', hash: { name: 'SHA-256' } },
    true,
    ['encrypt']
  );
};

const encryptAESKeyWithRSA = async (aesKey) => {
  try {
    if (!RSA_PUBLIC_KEY) {
      await loadRSAPublicKey();
    }

    const publicKey = await importRSAPublicKey(RSA_PUBLIC_KEY);

    const encryptedKey = await window.crypto.subtle.encrypt(
      { name: 'RSA-OAEP' },
      publicKey,
      aesKey
    );

    // Convert encrypted key to Base64
    const encryptedKeyBase64 = arrayBufferToHex(encryptedKey);
    return encryptedKeyBase64;
  } catch (error) {
    console.error('Error encrypting AES key:', error);
    throw error;
  }
};

const arrayBufferToHex = (buffer) => {
  const byteArray = new Uint8Array(buffer);
  return Array.from(byteArray).map((byte) => byte.toString(16).padStart(2, '0')).join('');
}

const base64ToUint8Array = (base64) => {
  const binaryString = window.atob(base64);
  const len = binaryString.length;
  const bytes = new Uint8Array(len);
  for (let i = 0; i < len; i++) {
    bytes[i] = binaryString.charCodeAt(i);
  }
  return bytes;
}

const generateAESKey = () => {
  return window.crypto.getRandomValues(new Uint8Array(AES_ENCRYPTION_KEY_LENGTH)); // 32 bytes = 256 bits
};

const isUrlEncoded = (data) => {
  try {
    return decodeURIComponent(data) !== data;
  } catch (e) {
    return false;
  }
};

const encrypt_get_params = (url, aesKey) => {
  const urlObj = new URL(url);
  const params = new URLSearchParams(urlObj.search);

  params.forEach((value, key) => {
    const encryptedValue = encrypt_data_aes(value, aesKey);
    params.set(key, encryptedValue);
  });

  urlObj.search = params.toString();

  return urlObj.toString();
};

const encrypt_post_data = async (bodySrc, contentType, aesKey) => {
  if (contentType.includes('application/json')) {
    try {
      const request_body_parsed = typeof bodySrc === 'string' ? JSON.parse(bodySrc) : bodySrc;
      const encryptedBody = encrypt_data_aes(JSON.stringify(request_body_parsed), aesKey);

      const data = {
        encrypted_data: encryptedBody
      }
      return JSON.stringify(data)
    } catch (error) {
      console.error("Failed to parse JSON body:", error);
      throw new Error("Invalid JSON body");
    }

  } else if (contentType.includes('multipart/form-data')) {
    //console.log("Encrypting formdata payload", bodySrc);

    const jsonObject = {};
    const fileConversionPromises = [];
    const filesConverted = [];
    const formData = new FormData();
    const fileEncryptFlag = process.env.REACT_APP_FILE_ENCRYPT_FLAG == '1';
    for (const [key, value] of bodySrc.entries()) {
      if (value instanceof File) {
        if (fileEncryptFlag) {
          fileConversionPromises.push(
            file_to_base64(value).then(base64Data => {
              const mime_type = value.type || 'application/octet-stream';
              filesConverted.push({
                content: base64Data,
                filename: value.name,
                filetype: mime_type
              })
            })
          );
        } else {
          formData.append(key, value)
        }
      } else {
        jsonObject[key] = value;
      }
    }
    await Promise.all(fileConversionPromises);
    if(filesConverted.length > 0 && fileEncryptFlag){
      jsonObject["file"] = filesConverted
    }

    const encryptedBody = encrypt_data_aes(JSON.stringify(jsonObject), aesKey);
    
    formData.append("encrypted_data", encryptedBody);
    return formData;

  } else if (contentType.includes('text/plain')) {
    return encrypt_data_aes(bodySrc, aesKey);
  } else if (contentType.includes('application/x-www-form-urlencoded')) {
    const params = new URLSearchParams(bodySrc);
    let jsonConvertedBody = {};
    params.forEach((value, key) => {
      jsonConvertedBody[key] = value;
    });

    return encrypt_data_aes(JSON.stringify(jsonConvertedBody), aesKey);
  }

  throw new Error("Unsupported Content-Type");
};

function encrypt_data_aes(data, aesKey) {
  const keyBytes = CryptoJS.lib.WordArray.create(aesKey);
  const iv = CryptoJS.lib.WordArray.random(AES_BLOCK_SIZE);

  const dataen = CryptoJS.AES.encrypt(data, keyBytes, {
    iv: iv,
    mode: CryptoJS.mode.CBC,
    padding: CryptoJS.pad.Pkcs7
  });

  const combinedData = iv.concat(dataen.ciphertext)
  const hexEncoded = CryptoJS.enc.Hex.stringify(combinedData)

  return hexEncoded;
}

const file_to_base64 = async (file) => {
  return new Promise((resolve, reject) => {
    const reader = new FileReader();

    reader.onloadend = () => {
      resolve(reader.result.split(",")[1]);
    };

    reader.onerror = reject;
    reader.readAsDataURL(file);
  });
}

const isTokenExpired = async (url, options, aesKey) => {
  const token = localStorage.getItem("api_token");

  if (options.skipRefresh) {
    console.log("Token expiry check skipped.");
    return await call_api(url, options);
  }

  if (token) {
    var decoded = jwt_decode(token);
    let currentDate = new Date();
    // JWT exp is in seconds
    if (decoded.exp * 1000 < currentDate.getTime()) {
      return await generate_token(url, options, aesKey);
    }
  }
  return await call_api(url, options)
};

const generate_token = async (url, options, aesKey) => {
  const formdata = new FormData();
  if (Cookies.get("refresh_token")) {
    var decode_reftoken = jwt_decode(Cookies.get("refresh_token"));
    let currentDate = new Date();

    if (decode_reftoken.exp * 1000 < currentDate.getTime()) {
      Cookies.remove("refresh_token");
      localStorage.clear();
      window.location.href = "/";
    } else {
      if(encryptFlag){
        const data = {
          refresh_token: Cookies.get("refresh_token")
        }
        const reqData = encrypt_data_aes(JSON.stringify(data), aesKey)
        formdata.append("encrypted_data", reqData);

        const AESEncryptedKey = await encryptAESKeyWithRSA(aesKey);
        options.headers = options.headers || {};
        options.headers["Security-Token"] = AESEncryptedKey
      }
      else {
        formdata.append("refresh_token", Cookies.get("refresh_token"));
      }
      try {
        const response = await fetch(
          process.env.REACT_APP_URL + "/get/access/token",
          {
            method: "POST",
            body: formdata,
            headers: options.headers
          }
        );

        if (response.ok) {
          const data3 = await response.json();
          console.log("access_token->", data3.access_token);
          localStorage.setItem("api_token", data3.access_token);
          options.headers["api-token"] = data3.access_token;
          return await call_api(url, options);
        } else {
          console.log("Error fetching token_:", response);
        }
      } catch (error) {
        console.log("Error fetching token_:", error);
      }
    }
  } else{
    Cookies.remove("api_token");
    localStorage.clear();
    window.location.href = "/";
  }
};
const isvalidjson = (str) => {
  try {
    JSON.parse(str);
  } catch (e) {
    return false;
  }
  return true;
};
const save_data = (url, options) => {
  let api_data = {};
  var jsonformdata = "";
  if (options.body) {
    if (isvalidjson(options.body)) {
      jsonformdata = options.body;
    } else {
      var object = {};
      options.body.forEach((value, key) => (object[key] = value));
      jsonformdata = JSON.stringify(object);
    }
  }

  const myDate = new Date();

  // Define the options for formatting
  const dateoptions = {
    day: "2-digit",
    month: "2-digit",
    year: "numeric",
    hour: "2-digit",
    minute: "2-digit",
    second: "2-digit",
  };

  // Format the date
  const formattedDate = myDate.toLocaleString("en-GB", dateoptions);

  api_data.created_at = formattedDate;
  api_data.data_write_for = "API";
  api_data.component_name = options.headers.component || null;
  api_data.url = url || null;
  api_data.method = options.method || null;
  api_data.data = jsonformdata || null;
  api_data.apiId = options.headers.apiId || null;
  api_data.component_id = options.headers.component_id || null;
  api_data.api_group_id = options.headers.api_group_id || null;
  api_data.added_at = moment().unix();
  api_data.log_id = localStorage.getItem("api_token");
  api_data.user_id = localStorage.getItem("in_userid");

  // let bucketName = process.env.REACT_APP_ENVIRONMENT + "_frontend_req_payload";
  // //setTimeout(() => {
  // addDoc(collection(db, bucketName), api_data).then((docRef) => {
  //   //console.log("Document written with ID: ", docRef.id);
  // });
  //}, 1000);
};
const call_api = async (url, options) => {

  save_data(url, options);
  //console.log("call_api_pilot->", url);
  
  const startTime = Date.now();
  const method = options && options.method || 'GET';
  
  try {
    const response = await fetch(url, options);

    if (!response.ok) {
      if (response.status === 401 && !logoutFlag) {
        logoutFlag = true
        alert("Please login in again. Session invalid.")
        localStorage.clear();
        window.location.href = "/";
      }
    }
    const jsonData = await response;
    
    // Log API end (success)
    const duration = Date.now() - startTime;
    try {
      logger.logApiEnd(url, method, response.status || 200, duration, null);
    } catch (error) {
      console.error('Error logging API end:', error);
    }
    
    // if (
    //   Cookies.get("parameter_value") !== "null" &&
    //   Cookies.get("parameter_value") !== undefined
    // ) {
    //   const ue = new UserExperior();
    //   ue.startRecording(Cookies.get("parameter_value"), {
    //     sessionReplay: {
    //       maskAllInputs: false,
    //       maskInputOptions: {
    //         password: true,
    //         email: true,
    //         tel: true,
    //         color: false,
    //         date: false,
    //         "datetime-local": false,
    //         month: false,
    //         number: false,
    //         range: false,
    //         search: false,
    //         text: false,
    //         time: false,
    //         url: false,
    //         week: false,
    //         textarea: false,
    //         select: false,
    //       },
    //     },
    //   });
  
    //   ue.logEvent('Response', {
    //     'headers': JSON.stringify(jsonData),
    //     'status': jsonData.status,
    //     'url': jsonData.url
    //   });
    // }
    // if(Cookies.get('parameter_value') !== 'null' && Cookies.get('parameter_value') !== undefined) {
    //   const ue = new UserExperior();
    //   ue.startRecording(process.env.REACT_APP_DEVREV_KEY, {
    //     sessionReplay: { 
    //         maskAllInputs: false,
    //         maskInputOptions: {
    //             password: false,
    //             email: false,
    //             tel: false,
    //             color: false,
    //             date: false,
    //             'datetime-local': false,
    //             month: false,
    //             number: false,
    //             range: false,
    //             search: false,
    //             text: false,
    //             time: false,
    //             url: false,
    //             week: false,
    //             textarea: false,
    //             select: false,
    //         }
    //     }
    //   });
  
    //   ue.logEvent('Response', {
    //     'headers': JSON.stringify(jsonData),
    //     'status': jsonData.status,
    //     'url': jsonData.url
    //   });
    // }
    return jsonData;
  } catch (error) {
    console.log("Error fetching data:", error);
    
    // Log API end (error)
    const duration = Date.now() - startTime;
    try {
      logger.logApiEnd(url, method, 0, duration, error.message || 'Unknown error');
    } catch (logError) {
      console.error('Error logging API error:', logError);
    }
    
    throw error;
  }
};

export default customFetch;